module.exports = __webpack_public_path__ + "static/process_img_card4-279e1bc4328b6fd5d74ce94dacca6f14.png";